import { render, staticRenderFns } from "./BoardLinkInput.vue?vue&type=template&id=3668bf59"
import script from "./BoardLinkInput.vue?vue&type=script&lang=js"
export * from "./BoardLinkInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports